<div *ngIf="isVisible">
  <div style="padding-top:20px; width:100%; height:100%; position:absolute; z-index:200; background-color:rgba(0, 0, 0, 0.2); box-sizing: border-box;">
    <div style="margin: auto; width: 200px; padding:20px; background-color:white;">
      <div style="text-align:center;padding-bottom:10px;">{{message}}</div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</div>
